import React,{useEffect} from 'react';
import './ServicesPage.css';
import Carousel from 'react-bootstrap/Carousel';
import AOS from 'aos';

const TopSlideSection = () => {
  useEffect(() => {
    AOS.init();
   
      window.scrollTo(0, 0)
   
  }, [])
  return (
    <div className='container-fluid' id='servicepage-top-slide-section'>
    <div className="row">
      <div className="col left-col" data-aos="fade-up" data-aos-offset="0"  data-aos-duration="1000"	>
      <Carousel className='slider' pause={"hover"|false} controls={false} indicators={false}>
      <Carousel.Item className='slider-items' interval={3000}>
        
      <h1>Cutting-edge Solar Solutions:</h1>
      <p> We specialize in designing and installing advanced solar panels and tube well systems, harnessing renewable energy to power homes, businesses, and agricultural operations efficiently and sustainably.</p>
      </Carousel.Item>
      <Carousel.Item className='slider-items' interval={3000}>
        
      <h1>Smart Automation Integration: </h1>
      <p>Our expertise extends to integrating sophisticated automation technologies, ensuring seamless control and optimization of energy usage, water resources, and overall operational efficiency for our clients.</p> 
      </Carousel.Item>
      <Carousel.Item className='slider-items' interval={3000}>
        <h1>Remote Monitoring via GSM/GPRS: </h1>
        <p>With our innovative GSM and GPRS control systems, clients can remotely monitor and manage their solar installations and pumps, enhancing convenience, reliability, and performance optimization from anywhere in the world.</p>
         
      </Carousel.Item>
      <Carousel.Item className='slider-items' interval={3000}>
        <h1>Tailored Solutions for Agricultural Needs:</h1>
        <p> We offer customized solar-powered pumping solutions tailored to agricultural requirements, providing reliable water access for irrigation, livestock, and farm operations, contributing to increased productivity and sustainability.</p>
      </Carousel.Item>
      <Carousel.Item className='slider-items' interval={3000}>
        <h1>Comprehensive Support and Maintenance: </h1>
        <p>Our commitment doesn't end with installation. We provide ongoing support and maintenance services, ensuring our clients' solar and automation systems operate at peak performance levels, maximizing their long-term investment benefits.</p>
      </Carousel.Item>
    </Carousel>
      </div>
      <div className="col right-col">
        &nbsp;
      </div>
      
    </div>
    <hr />
    </div>
  )
}

export default TopSlideSection
